export default {
  path: 'work-plan',
  component: () => import('@/views/Route'),
  children: [
    {
      path: '',
      name: 'Work Plan',
      component: () => import('@/views/menus/workPlan/Index'),
      meta: {
        permission: true
      }
    }
  ]
}
